export default "__VITE_ASSET__BL5G2wMp__"